export class DocumentHasLinkedResultsError extends Error {
  readonly linkedResultCount: number;

  constructor(linkedResultCount: number) {
    super(`С документом связаны показатели: ${linkedResultCount}.`);
    this.name = 'DocumentHasLinkedResultsError';
    this.linkedResultCount = linkedResultCount;
  }
}

// The deployed Edge Function now returns a machine-readable code. The text
// fallback keeps the client safe while an older function deployment is still
// serving a request: it never treats AI review drafts as lab_results.
export function linkedResultCountFromDeletionError(payload: unknown): number | undefined {
  if (!payload || typeof payload !== 'object') return undefined;
  const value = payload as { code?: unknown; linkedResultCount?: unknown; error?: unknown };
  const count = typeof value.linkedResultCount === 'number' && Number.isInteger(value.linkedResultCount)
    ? value.linkedResultCount
    : undefined;
  if (value.code === 'DOCUMENT_HAS_LINKED_RESULTS' && count !== undefined && count > 0) return count;
  if (typeof value.error !== 'string') return undefined;
  const legacy = value.error.match(/С документом связаны показатели:\s*(\d+)/i);
  return legacy ? Number(legacy[1]) : undefined;
}
